import { render, staticRenderFns } from "./c_auxiliary_box.vue?vue&type=template&id=b10752e6&scoped=true"
import script from "./c_auxiliary_box.vue?vue&type=script&lang=js"
export * from "./c_auxiliary_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10752e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10752e6')) {
      api.createRecord('b10752e6', component.options)
    } else {
      api.reload('b10752e6', component.options)
    }
    module.hot.accept("./c_auxiliary_box.vue?vue&type=template&id=b10752e6&scoped=true", function () {
      api.rerender('b10752e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_auxiliary_box.vue"
export default component.exports